// oktaConfig.js
import { OktaAuth } from '@okta/okta-auth-js';

const oktaConfig = {
  issuer: "https://portalsso.elevancehealth.com/oauth2/aus2403lckCZkYJHV4h7", // your Okta authorization server
  clientId: "0oaggoyxtp0EY7E1u4h7", // your Okta app client ID
  redirectUri: window.location.origin + "/login/callback", // must match Okta Admin Console
  pkce: true,
  scopes: ["openid", "profile", "email"]
};

export const oktaAuth = new OktaAuth(oktaConfig);